import React, { useEffect, useRef, useState } from "react";
//------------------------------------------------

//-----------------------------------------------------------------------
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// import JoditEditor from "jodit-react";
import { useCreateQuestionMutation } from "App/services/QuestionServiceApi";
import { useGetAllChapterQuery } from "App/services/chapterServiceApi";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import EditorComponents from "components/Editor/EditorComponents";
import JoditEditor from "jodit-react";
import ChapterDragDrop from "./ChapterDragDrop";

// import { config } from "components/EditorConfig";

// import JoditEditor from "jodit-react";
// import { config } from "components/EditorConfig";
// import { CKEditor } from "ckeditor4-react";

function NotesFormDialogue({ open, onClose }) {
  // const editorRef = useRef(null);
  const editor = useRef(null);

  const location = useLocation();
  const data = location.state || {};
  // console.log(data)

  const [noteContent, setNoteContent] = useState("");
  const [chapterId, setChapterId] = useState(data.data);
  const [categoryId, setCategoryId] = useState(data.categoryId);
  const [videoLink, setVideoLink] = useState("");
  const [appliedChapters, setAppliedChapters] = useState([]);

  const {
    data: allChapters,
    error: questionsError,
    isLoading: questionsLoading,
  } = useGetAllChapterQuery();
  const [createQuestion, { isLoading }] = useCreateQuestionMutation();

  useEffect(() => {
    if (data.data && allChapters && allChapters.length > 0) {
      const currentId = Number(data.data);
      const current = allChapters.find((c) => c.id === currentId);
      setAppliedChapters(current ? [current.id] : [currentId]);
    }
  }, [data.data, allChapters]);

  const handleClose = () => {
    onClose(false);
  };

  // const handleChange = (e, editor) => {
  //   setNoteContent(editor.getData(e));
  // };

  const handleModelChange = (event) => {
    setNoteContent(event);
  };
  const handleAddNotes = async (event) => {
    event.preventDefault();

    if (noteContent) {
      let newNoteContent = noteContent.split('<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>')
      const chapterIds = appliedChapters.length > 0 ? appliedChapters : [chapterId].filter(Boolean);
       try {
        await createQuestion({ notes: newNoteContent[0], video_link: videoLink, chapterId: chapterIds[0], categoryId, chapters: chapterIds });
        toast.success("Notes Successfully Created!");
        handleClose();
        setNoteContent("");
        setVideoLink("");

      } catch (error) {
        toast.error("Something went wrong!!");
      }
    } else {
      toast.error("Required to Notes");
    }
  };
  // const handleEditorChange = (_, editor) => {
  //   const data = editor.getData();
  //   setNoteContent(data);
  // };
  // const handleEditorChange = (content) => {
  //   setNoteContent(content);
  // };

  // const config = {
  //   controls: {
  //     lineHeight: {
  //       list: [1, 1.5, 2, 2.5, 3, 3.5],
  //       command: "lineHeight",
  //     },
  //   },

  // };

  //   const editorConfig = {
  //     toolbar: [
  //         // Document functionalities
  //         { name: 'document', items: ['Source', '-', 'NewPage', 'Preview', 'Print', '-', 'Templates'] },
  //         // Clipboard functionalities
  //         { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
  //         // Editing functionalities
  //         { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'] },
  //         // Basic styles
  //         { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
  //         // Paragraph styles
  //         { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'] },
  //         // Links
  //         { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
  //         // Insert functionalities
  //         { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak', 'Iframe'] },
  //         // Styles
  //         { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
  //         // Colors
  //         { name: 'colors', items: ['TextColor', 'BGColor'] },
  //         // Tools
  //         { name: 'tools', items: ['Maximize', 'ShowBlocks', '-', 'About'] }
  //     ],
  //     // File and image upload capabilities
  //     filebrowserUploadUrl: '/uploader/upload.php',
  //     filebrowserBrowseUrl: '/browser/browse.php',
  //     filebrowserImageUploadUrl: '/uploader/upload.php?type=Images',
  //     filebrowserFlashUploadUrl: '/uploader/upload.php?type=Flash',
  //     // Extra plugins for additional features
  //     extraPlugins: 'autogrow,divarea,font,colorbutton,justify,print,preview,find,flash,iframe',
  //     // Set default height for the editor
  //     height: 400,
  //     // Auto-growing editor height based on content
  //     autoGrow_minHeight: 200,
  //     autoGrow_maxHeight: 600,
  //     autoGrow_bottomSpace: 50,
  //     removePlugins: 'resize', // Prevents resizing editor by dragging corners
  // };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        component: "form",
        onSubmit: handleAddNotes,
        style: { width: "60%", maxWidth: "none" },
      }}
    >
      <DialogTitle>Add Note</DialogTitle>
      <DialogContent>
        <JoditEditor
          ref={editor}
          value={noteContent}
          // config={config}
          onChange={(newNoteContent) => setNoteContent(newNoteContent)}
          
        />
        {/* <FroalaEditor
          tag="textarea"
          config={{
            placeholderText: "Text here...",
          }}
          model={noteContent}
          onModelChange={handleModelChange}
        /> */}

        {/* <EditorComponents content={noteContent} handleChangeContent={handleModelChange}/> */}

        {/* <CKEditor editor={ClassicEditor} onChange={(e, editor)=>handleChange(e, editor)}  /> */}

        {/* <Editor
          apiKey={`${EDITOR_API_KEY}`}
          onInit={(_evt, editor) => (editorRef.current = editor)}
          initialValue={noteContent}
          init={inijt}
          onEditorChange={handleEditorChange}
        /> */}
<TextField
            margin="dense"
            id="videoLink"
            label="Video Link"
            fullWidth
            variant="outlined"
            value={videoLink}
            onChange={(e) => setVideoLink(e.target.value)}
          />

        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
            Chapter Applied
          </Typography>
          {questionsLoading ? (
            <Typography variant="body2" color="text.secondary">
              Loading chapters...
            </Typography>
          ) : (
            <ChapterDragDrop
              chapters={allChapters || []}
              value={appliedChapters}
              onChange={setAppliedChapters}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" disabled={isLoading} name="submit">
          Submit {isLoading && "Loading..."}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
// }

export default NotesFormDialogue;
